import { ForwardToInboxOutlined, HeadsetMicOutlined, WhatsApp } from "@mui/icons-material";

export const endpointName = "support";

export const SUPPORT_BUTTON = [
    {
        id: 1,
        title: "WhatsApp",
        icon: <WhatsApp sx={{ color: "primary.main" }} />,
        titleValue: "מעבר לנציג",
        value: "https://api.whatsapp.com/send?phone=972557773229",
    },
    {
        id: 2,
        title: "טלפון",
        icon: <HeadsetMicOutlined sx={{ color: "primary.main" }} />,
        titleValue: "055-777-3229",
        value: "tel:0557773229",
    },
    {
        id: 3,
        title: "דוא\"ל",
        icon: <ForwardToInboxOutlined sx={{ color: "primary.main" }} />,
        titleValue: "support@mybee.co.il",
        value: "mailto:support@mybee.co.il",
    },
]

export const SUBJECT_TYPES = [
    { id: "TECHNICAL_ISSUE_HELP", name: "TECHNICAL_ISSUE_HELP" },
    { id: "LOGIN_ERROR", name: "LOGIN_ERROR" },
    { id: "USAGE_QUESTION", name: "USAGE_QUESTION" },
    { id: "BUG_REPORT", name: "BUG_REPORT" },
]